// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as DriverEarningsStateMapper from "../entity-mapper/DriverEarningsStateMapper.bs.js";

function execute(data, msisdn) {
  return DriverEarningsStateMapper.WeeklyEarningSummary.execute(data, msisdn);
}

var DriverEarningsResponseConverterConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.DriverResponseConverter;

var DriverEarningsResponseConverter = partial_arg(DriverEarningsResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$1(data, msisdn) {
  return DriverEarningsStateMapper.WeeklyEarningDetail.execute(data, msisdn);
}

var DriverDailyEarningsResponseConverterConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.DriverResponseConverter;

var DriverDailyEarningsResponseConverter = partial_arg$1(DriverDailyEarningsResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  DriverEarningsResponseConverterConfig ,
  DriverEarningsResponseConverter ,
  DriverDailyEarningsResponseConverterConfig ,
  DriverDailyEarningsResponseConverter ,
  
}
/* DriverEarningsResponseConverter Not a pure module */
